import React from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'

const KeyStats = ({ tossData, liveScoreData }) => {
  const runs = liveScoreData?.sLastFiveOvers?.split('/')
  const wicket = runs && runs[1]?.split(' ')
  return (
    <section className={`${styles.keyStats} common-box p-0 mb-3`}>
      <div className={`${styles.head}`}>
        <p className="font-bold mb-0">{'Key Stats'}</p>
      </div>
      <div className={`${styles.content} d-flex flex-wrap justify-content-between`}>
        <p
          className={`${styles.item} ${styles.halfItem} text-secondary col-6 col-xl-12 d-flex flex-column flex-sm-row justify-content-between`}>
          <span className="text-dark font-semi flex-shrink-0 d-block d-lg-inline">{'Partnership'} :</span>
          <span className="text-sm-end">
            {liveScoreData?.oCurrentPartnership?.nRuns !== null ? liveScoreData?.oCurrentPartnership?.nRuns + '(' + liveScoreData?.oCurrentPartnership?.nBalls + ')' : '-'}
          </span>
        </p>
        <p
          className={`${styles.item} ${styles.halfItem} text-secondary col-6 col-xl-12 d-flex flex-column flex-sm-row justify-content-between`}>
          <span className="text-dark font-semi flex-shrink-0 d-block d-lg-inline">
            {'Last'} 5 {'Overs'} :
          </span>
          <span className="text-sm-end">
            {runs ? runs[0] + ` ${'Runs'}, ` : '-'} {wicket && wicket[0] + ` ${'Wickets'}`}{' '}
          </span>
        </p>
        <p className={`${styles.item} text-secondary col-lg-12 col-12 d-flex flex-column flex-sm-row justify-content-between`}>
          <span className="text-dark font-semi flex-shrink-0">{'LastWickets'} :</span>
          <span className="text-sm-end">
            {liveScoreData?.oLastWicket === null || liveScoreData?.oLastWicket?.oBatter === null ? '-' : liveScoreData?.oLastWicket?.oBatter?.sFullName +
                ' ' +
                liveScoreData?.oLastWicket?.nRuns +
                '(' +
                liveScoreData?.oLastWicket?.nBallFaced +
                ') ' +
                '- ' +
                liveScoreData?.oLastWicket?.sHowOut}
          </span>
        </p>
        <p className={`${styles.item} text-secondary col-lg-12 col-12 d-flex flex-column flex-sm-row justify-content-between`}>
          <span className="text-dark font-semi flex-shrink-0">{'Toss'} :</span>
          <span className="text-sm-end">
            {tossData?.oWinnerTeam === null ? '-' : tossData?.oWinnerTeam?.sTitle + ' (' + tossData?.eDecision + ')'}
          </span>
        </p>
      </div>
    </section>
  )
}

KeyStats.propTypes = {
  tossData: PropTypes.object,
  liveScoreData: PropTypes.object
}

export default KeyStats
